// CacheKey 3e3e0e701de9a0f42850223c035f3b81
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ARCH_CARE": {
    models: {
      patient: "member",
      Patient: "Member",
      patient_list_config: "member list config",
      patient_list_configs: "member list configs",
      patient_tags: "Member Tags",
      patients: "members",
      Patients: "Members",
      unit: "team number",
      Unit: "Team Number",
      units: "team numbers",
      Units: "Team Numbers"
    },
    exports: {
      defaults: {
        patient: {
          id: "Member ID",
          name: "Member Name"
        },
        unit: {
          name: "Team Number"
        }
      }
    },
    ribbon: {
      patient_information: "Member Information"
    },
    admitted_patients: {
      title: "Admitted Members"
    },
    encounter: {
      mrn: "Member ID",
      unit_id: "Team Number"
    },
    monitored_patients: {
      title: "Monitored Members"
    },
    my_patient_panel: {
      title: "My Member Panel"
    },
    pathway_patients: {
      title: "Pathway Members"
    },
    patient_list: {
      title: "Member List"
    },
    patient_list_configs: {
      title: "Member List Configs"
    },
    patient_rounding_assignments: {
      title: "Member Rounding Assignments"
    },
    patients: {
      title: "Members"
    },
    patients_search: {
      nav_menu: "Members"
    },
    plans: {
      patient_information: "Member Info"
    }
  }
}

